import React from 'react'
import { Box } from '@mui/material'
import { __t } from '../../../../../i18n/t'
import { toInt } from '../../format'
import { LimitMode, digits, limitExplain } from '../../model'
import { useWiz } from '../../state/WizardContext'
import { Ask, FieldError } from '../../ui/basics'
import { LabeledInput, RadioCard, RadioRow, Seg } from '../../ui/controls'
import { C } from '../../ui/tokens'

const panelSx = { display: 'flex', flexDirection: 'column', gap: 1.25, p: 2, border: `1px solid ${C.line}`, borderRadius: '12px', bgcolor: C.surface, maxWidth: 640 } as const
const sentenceSx = { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1.25, fontSize: 15, color: C.ink } as const
// A caixa das horas e a palavra "horas" quebram de linha juntas: a unidade não fica sozinha embaixo do campo.
const hoursPairSx = { display: 'inline-flex', flexWrap: 'nowrap', alignItems: 'center', gap: 1.25 } as const

/** "Quantas vezes cada cliente pode usar?": sem limite, ou a frase "Até [N] vezes [a cada|no total] [H] horas". */
export const LimitSection: React.FC = () => {
  const { d, set, fe } = useWiz()
  const n = toInt(d.limitN)
  const h = toInt(d.limitHours)
  const errN = fe['f-lim-n']
  const errH = fe['f-lim-h']
  const everyMode = d.limitMode === LimitMode.every
  return (
    <Ask id="h-limit" wrapId="f-limit" title={__t('Quantas vezes cada cliente pode usar?')}>
      <RadioRow labelledBy="h-limit">
        <RadioCard name="limit" checked={!d.hasLimit} onChange={() => set(x => ({ ...x, hasLimit: false }))} title={__t('Sem limite')} />
        <RadioCard name="limit" checked={d.hasLimit} onChange={() => set(x => ({ ...x, hasLimit: true }))} title={__t('Com limite')} />
      </RadioRow>
      {d.hasLimit ? (
        <Box sx={panelSx}>
          <Box sx={sentenceSx}>
            <span>{__t('Até')}</span>
            <LabeledInput id="f-lim-n" label={__t('Quantas vezes')} hideLabel width={72} center inputMode="numeric" value={d.limitN} invalid={!!errN} describedBy={errN ? 'lim-n-err' : undefined} onChange={e => set(x => ({ ...x, limitN: digits(e.target.value, 3) }))} />
            <span>{n === 1 ? __t('vez') : __t('vezes')}</span>
            <Seg
              value={d.limitMode}
              onChange={v => set(x => ({ ...x, limitMode: v }))}
              label={__t('Forma de contar')}
              options={[{ value: LimitMode.every, label: __t('a cada') }, { value: LimitMode.total, label: __t('no total') }]}
            />
            {everyMode ? (
              <Box sx={hoursPairSx}>
                <LabeledInput id="f-lim-h" label={__t('Intervalo em horas')} hideLabel width={80} center inputMode="numeric" value={d.limitHours} invalid={!!errH} describedBy={errH ? 'lim-h-err' : undefined} onChange={e => set(x => ({ ...x, limitHours: digits(e.target.value, 4) }))} />
                <span>{h === 1 ? __t('hora') : __t('horas')}</span>
              </Box>
            ) : null}
          </Box>
          <Box component="span" sx={{ fontSize: 13, color: C.muted, lineHeight: 1.45 }}>{limitExplain(d)}</Box>
          {errN ? <FieldError id="lim-n-err">{errN}</FieldError> : null}
          {errH ? <FieldError id="lim-h-err">{errH}</FieldError> : null}
        </Box>
      ) : null}
    </Ask>
  )
}
